import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(default)/search/components/SearchForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(default)/search/components/SearchLazyLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/Analytics/Facebook/FBPixelScript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/Analytics/Google/GAScript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/Article/ArticleSimple.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/Article/atoms/CoverPhoto.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/Article/styles/authorIntro.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/Thumbnail/Thumbnail.tsx");
